import { HELPED_KEY } from '../const';

export const UPDATE_STATS = 'TT UPDATE STATS';
export const SET_OPTIONS = 'TT SET OPTIONS';
export const SELECT_SIZE = 'TT SELECT SIZE';
export const UPDATE_STEPS = 'TT UPDATE STEPS';
export const SET_MODE = 'TT SET MODE';
export const SHOW_HELP = 'TT SHOW HELP';

export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const selectSize = size => ({ type: SELECT_SIZE, size });
export const updateSteps = update => ({ type: UPDATE_STEPS, update });
export const setMode = mode => ({ type: SET_MODE, mode });
export const showHelp = show => ({ type: SHOW_HELP, show });
export const setHelped = () => ({ type: HELPED_KEY });
